import { priceFactory } from 'factories';
import { BatchCollect, BatchCollectConsignment } from 'types';
import { convertTimestampToDate } from 'helpers';

function populateBatchConsignments(
  batchConsignments: any[] = []
): BatchCollectConsignment[] {
  return batchConsignments.map((batchConsignment) => {
    const { code, quantity, subTotalPrice } = batchConsignment;

    return {
      code: code || '',
      quantity: quantity || 0,
      subTotalPrice: priceFactory(subTotalPrice),
    };
  });
}

export function batchCollectFactory(params: any = {}): BatchCollect {
  const { carrier, consignments, cpf, date, name } = params;

  return {
    carrier: carrier || '',
    cpf: cpf || '',
    name: name || '',
    consignments: populateBatchConsignments(consignments),
    date: convertTimestampToDate(date || 0),
  };
}

export function batchCollectHistoryFactory(params: any[] = []): BatchCollect[] {
  return params.map((param: any) => batchCollectFactory(param));
}
